<template>
  <h4 v-if="!isOnline" class="disconnected_message center_text pa4">
    Please connect to<br/>internet to use HiHello
  </h4>
</template>

<script>

export default {
  name: 'online-status',

  data() {
    return {
      isOnline: true,
    };
  },

  methods: {
    updateOnlineStatus({ type }) {
      this.isOnline = type === 'online';
      if (this.isOnline) {
        this.showSuccessNotification('You are back online!');
      } else {
        this.showErrorNotification('You went offline! You need internet to use this application.');
      }
    },
  },

  mounted() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  },

  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
};
</script>

<style scoped>

</style>
